import { useEffect, useState } from "react";
import { ChallengeMatchOverviewTable } from "../components/ChallengeMatchOverviewTable/ChallengeMatchOverviewTable";
import {
  ChallengeEventType,
  ChallengeEventTypes,
} from "../directus/collections";
import { MatchEnigmaIds } from "../services/enigmaStats.service";
import { OpenModalProps, useDialog } from "./DialogProvider";

export type ChallengeMatchOverviewOpenModalProps = {
  title?: string;
  highlightColumns?: ChallengeEventType[];
  data?: MatchEnigmaIds[];
  loading?: boolean;
  challengeId?: string;
};

function ChallengeMatchOverviewDialogTitle(
  props: ChallengeMatchOverviewOpenModalProps
) {
  return (
    <span>
      Informazioni segmento partite: <b>{props.title}</b> (
      {props.data?.length ?? 0})
    </span>
  );
}

function ChallengeMatchOverviewDialogContent(
  props: ChallengeMatchOverviewOpenModalProps
) {
  return props.data ? (
    <ChallengeMatchOverviewTable
      challengeId={props.challengeId ?? ""}
      data={props.data}
      columns={ChallengeEventTypes}
      highlightColumns={props.highlightColumns}
      totalCount={props.data.length}
      sx={{ maxHeight: "70vh" }}
    />
  ) : (
    <>Nessun risultato</>
  );
}

export function useChallengeMatchOverviewDialog(id?: string) {
  const dialog = useDialog();
  const dialogId = id ?? "challenge-match-overview-dialog";
  const [props, setProps] =
    useState<ChallengeMatchOverviewOpenModalProps | null>(null);

  useEffect(() => {
    const startingProps: OpenModalProps = {
      loading: true,
      slotProps: { dialog: { maxWidth: "lg" } },
    };

    dialog.create(dialogId, startingProps, { onConflict: "replace" });
  }, []);

  const openModal = (props: ChallengeMatchOverviewOpenModalProps) => {
    console.log("opening dialog", props);
    
    dialog.open(dialogId, {
      loading: props.loading,
      title: <ChallengeMatchOverviewDialogTitle {...props} />,
      content: <ChallengeMatchOverviewDialogContent {...props} />,
      slotProps: { dialog: { maxWidth: "lg" } },
    });
    
    setProps(props);
  };

  const close = () => {
    dialog.remove(dialogId);
  };

  const setLoading = (loading: boolean) => {
    dialog.update(dialogId, (props) => ({ ...props, loading }));

    setProps((prev) => {
      if (!prev) {
        throw new Error(
          "Dialog" + dialogId + " not opened yet. Cannot set loading."
        );
      }
      return { ...prev, loading };
    });
  };

  const setData = (data: MatchEnigmaIds[]) => {
    const updatedProps = { ...(props ?? {}), data };

    dialog.update(dialogId, (prev) => ({
      ...prev,
      loading: false,
      title: <ChallengeMatchOverviewDialogTitle {...updatedProps} />,
      content: <ChallengeMatchOverviewDialogContent {...updatedProps} />,
    }));

    setProps(updatedProps);
  };

  return {
    openModal,
    close,
    setLoading,
    setData,
  };
}
